import React from 'react'
import { useWindowSize } from 'hooks'
import { DesktopOverviewLoading } from './desktop'
import { MobileOverviewLoading } from './mobile'
export const OverviewLoading: React.FC = () => {
  const { isMobile, isTablet } = useWindowSize()
  const smaller = isMobile || isTablet
  return smaller ? <MobileOverviewLoading /> : <DesktopOverviewLoading />
}
